import * as React from 'react';
import clsx from 'clsx';

type Props = Readonly<{
	className?: string,
}>

function Logo({className = ""}: Props) {
	return (
		<div className={clsx("logo ease-mine transition-all duration-300", className)}/>
	);
}

export default Logo;
